import { setCountryCodeInSession } from "../setCountryCodeInSession/setCountryCodeInSession";
import { setCustomerInformationInLocalStorage } from "../setCustomerInformationInLocalStorage/setCustomerInformationInLocalStorage";
import { clearCustomerInformationFromLocalStorage } from "../clearCustomerDataInLocalStorage/clearCustomerDataInLocalStorage";

export const authenticateUser = () => {
  return (dispatch, getState, { api }) => {
    return api.authenticateUser().then(
      ({ result }) => {
        // 🚨 For logged in guest users there won't be any data
        if (result.customers.length === 0) {
          return { wasSuccessful: false };
        }

        let customersData = result.customers;
        let registrantData = null;

        // Set onedotcomac in Cookies for eisting users
        document.cookie = `onedotcomac=true;path=/;domain=.one.com;expires=${new Date(new Date().setFullYear(new Date().getFullYear() + 1))};`;

        // Default countryCode in the session, so Cart currency can be updated correctly
        dispatch(setCountryCodeInSession(result.customers[0].country));

        // In case an user edits its data, we must ensure that the latest information is displayed.
        // Since the data retrieved from authenticateUser doesn’t get updated (saved in db) until the user makes a purchase,
        // we need to call the on-session endpoint, which returns uodated data.
        return api
          .getUserDataFromSession()
          .then(({ result: userDataFromSession }) => {
            if (userDataFromSession.customer) {
              const usersFullNameOrCompanyName =
                userDataFromSession.customer.company ||
                `${userDataFromSession.customer.firstName} ${userDataFromSession.customer.lastName}`;

              customersData = customersData.map((customerData) => {
                if (
                  customerData.legalEntityName === usersFullNameOrCompanyName
                ) {
                  registrantData = userDataFromSession.registrant;

                  return {
                    legalEntityName: usersFullNameOrCompanyName,
                    ...userDataFromSession.customer,
                  };
                } else {
                  return {
                    ...customerData,
                  };
                }
              });
            }

            if (registrantData) {
              Object.entries(registrantData).forEach(
                ([fieldName, fieldValue]) => {
                  if (fieldValue && fieldValue !== "") {
                    dispatch(
                      setCustomerInformationInLocalStorage(
                        fieldName,
                        fieldValue,
                      ),
                    );
                  }
                },
              );
            } else {
              dispatch(clearCustomerInformationFromLocalStorage());
            }

            return { wasSuccessful: true, customersData };
          });
      },
      (err) => {
        return { wasSuccessful: false };
      },
    );
  };
};
